/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCreativeDto } from '../models/CreateCreativeDto';
import type { CreateCreativeResponseDto } from '../models/CreateCreativeResponseDto';
import type { CreateFromUploadDto } from '../models/CreateFromUploadDto';
import type { CreateFromUploadResponseDto } from '../models/CreateFromUploadResponseDto';
import type { CreativeChatBodyDto } from '../models/CreativeChatBodyDto';
import type { CreativeChatEntity } from '../models/CreativeChatEntity';
import type { CreativeCompositionResponseDto } from '../models/CreativeCompositionResponseDto';
import type { CreativeEntity } from '../models/CreativeEntity';
import type { CreativeGenerationResponseDto } from '../models/CreativeGenerationResponseDto';
import type { CreativeVersionDetailResponseDto } from '../models/CreativeVersionDetailResponseDto';
import type { CreativeVersionListResponseDto } from '../models/CreativeVersionListResponseDto';
import type { CreativeWithChatResponseDto } from '../models/CreativeWithChatResponseDto';
import type { GenerateBeatClipDto } from '../models/GenerateBeatClipDto';
import type { GenerateCreativeContentDto } from '../models/GenerateCreativeContentDto';
import type { GeneratedBeatClipResponseDto } from '../models/GeneratedBeatClipResponseDto';
import type { RegenerateReelMusicDto } from '../models/RegenerateReelMusicDto';
import type { RegenerateReelMusicResponseDto } from '../models/RegenerateReelMusicResponseDto';
import type { RenderCreativeCompositionDto } from '../models/RenderCreativeCompositionDto';
import type { RenderedCompositionResponseDto } from '../models/RenderedCompositionResponseDto';
import type { SaveCreativeCompositionDto } from '../models/SaveCreativeCompositionDto';
import type { SynthBeatVoDto } from '../models/SynthBeatVoDto';
import type { SynthBeatVoResponseDto } from '../models/SynthBeatVoResponseDto';
import type { UpdateCreativeDto } from '../models/UpdateCreativeDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CreativeService {
    /**
     * Stream a creative chat response via SSE
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static creativeChatControllerChatV1(
        requestBody: CreativeChatBodyDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creative/chat',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Trigger background generation of suggestion creatives
     * @returns any Generation started
     * @throws ApiError
     */
    public static creativeControllerGenerateSuggestionsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/suggestions/generate',
        });
    }
    /**
     * Discard all suggested Posts and regenerate fresh ideas
     * @returns any Regeneration started
     * @throws ApiError
     */
    public static creativeControllerRegenerateAllIdeasV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/suggestions/regenerate-all',
        });
    }
    /**
     * Regenerate all suggestions for a specific channel
     * @param channel Channel to regenerate
     * @returns any Regeneration started
     * @throws ApiError
     */
    public static creativeControllerRegenerateChannelSuggestionsV1(
        channel: 'instagram' | 'facebook' | 'linkedin' | 'pinterest',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/suggestions/regenerate/{channel}',
            path: {
                'channel': channel,
            },
        });
    }
    /**
     * Get all ready suggestion creatives for the current business
     * @returns CreativeEntity
     * @throws ApiError
     */
    public static creativeControllerFindSuggestionsV1(): CancelablePromise<Array<CreativeEntity>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/suggestions',
        });
    }
    /**
     * Get all creatives for the current business
     * @returns CreativeEntity
     * @throws ApiError
     */
    public static creativeControllerFindAllV1(): CancelablePromise<Array<CreativeEntity>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives',
        });
    }
    /**
     * Create a new creative with chat
     * @param requestBody
     * @returns CreateCreativeResponseDto
     * @throws ApiError
     */
    public static creativeControllerCreateV1(
        requestBody: CreateCreativeDto,
    ): CancelablePromise<CreateCreativeResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get the persistent assistant chat with messages
     * @returns any Assistant chat with messages (or empty)
     * @throws ApiError
     */
    public static creativeControllerGetAssistantChatV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/assistant-chat',
        });
    }
    /**
     * Get the persistent Brand Kit chat with messages
     * @returns any Brand Kit chat with messages (or empty)
     * @throws ApiError
     */
    public static creativeControllerGetBrandChatV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/brand-chat',
        });
    }
    /**
     * Get the persistent onboarding interview chat with messages
     * @returns any Onboarding chat with messages (or empty)
     * @throws ApiError
     */
    public static creativeControllerGetOnboardingChatV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/onboarding-chat',
        });
    }
    /**
     * Get the active chat with messages for a creative
     * @param creativeId Creative ID
     * @returns CreativeChatEntity
     * @throws ApiError
     */
    public static creativeControllerGetActiveChatV1(
        creativeId: string,
    ): CancelablePromise<CreativeChatEntity> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/{creativeId}/chat',
            path: {
                'creativeId': creativeId,
            },
            errors: {
                404: `Chat not found`,
            },
        });
    }
    /**
     * Get all images generated for a creative (from chat history)
     * @param creativeId Creative ID
     * @returns any List of generated images
     * @throws ApiError
     */
    public static creativeControllerGetGeneratedImagesV1(
        creativeId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/{creativeId}/images',
            path: {
                'creativeId': creativeId,
            },
        });
    }
    /**
     * Get all videos generated for a creative (from chat history)
     * @param creativeId Creative ID
     * @returns any List of generated videos
     * @throws ApiError
     */
    public static creativeControllerGetGeneratedVideosV1(
        creativeId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/{creativeId}/videos',
            path: {
                'creativeId': creativeId,
            },
        });
    }
    /**
     * Get the captured SocialKit creation process (rubric score + trail) for a creative
     * @param creativeId Creative ID
     * @returns CreativeGenerationResponseDto
     * @throws ApiError
     */
    public static creativeControllerGetGenerationV1(
        creativeId: string,
    ): CancelablePromise<CreativeGenerationResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/{creativeId}/generation',
            path: {
                'creativeId': creativeId,
            },
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Get the layered, editable Composition document (+ PostSpec) for a creative
     * @param creativeId Creative ID
     * @returns CreativeCompositionResponseDto
     * @throws ApiError
     */
    public static creativeControllerGetCompositionV1(
        creativeId: string,
    ): CancelablePromise<CreativeCompositionResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/{creativeId}/composition',
            path: {
                'creativeId': creativeId,
            },
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Persist an edited Composition document for a creative (the editor save path)
     * @param creativeId Creative ID
     * @param requestBody
     * @returns CreativeCompositionResponseDto
     * @throws ApiError
     */
    public static creativeControllerSaveCompositionV1(
        creativeId: string,
        requestBody: SaveCreativeCompositionDto,
    ): CancelablePromise<CreativeCompositionResponseDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/creatives/{creativeId}/composition',
            path: {
                'creativeId': creativeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Re-render an edited Composition into a published master and swap it onto the creative
     * @param creativeId Creative ID
     * @param requestBody
     * @returns RenderedCompositionResponseDto
     * @throws ApiError
     */
    public static creativeControllerRenderCompositionV1(
        creativeId: string,
        requestBody?: RenderCreativeCompositionDto,
    ): CancelablePromise<RenderedCompositionResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{creativeId}/composition/render',
            path: {
                'creativeId': creativeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Creative or composition not found`,
            },
        });
    }
    /**
     * Reset a customized platform variant to derived: unpin it and re-derive from the post canonical (async)
     * @param creativeId Creative ID (a platform variant)
     * @returns any Re-derivation started
     * @throws ApiError
     */
    public static creativeControllerRederiveVariantV1(
        creativeId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{creativeId}/rederive',
            path: {
                'creativeId': creativeId,
            },
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Generate + apply a new background clip for one reel beat (t2v from a prompt / i2v from an uploaded image). Async: returns 202; poll the composition for the beat’s new clip.
     * @param creativeId Creative ID
     * @param requestBody
     * @returns GeneratedBeatClipResponseDto
     * @throws ApiError
     */
    public static creativeControllerGenerateBeatClipV1(
        creativeId: string,
        requestBody: GenerateBeatClipDto,
    ): CancelablePromise<GeneratedBeatClipResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{creativeId}/generate-beat-clip',
            path: {
                'creativeId': creativeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Regenerate the reel’s music bed, optionally steered by a prompt ("slow jazzy piano"). Async 202: the track generates off-request (~2-3 min) and lands on composition.music.src; poll the composition. Free (no credit).
     * @param creativeId Creative ID
     * @param requestBody
     * @returns RegenerateReelMusicResponseDto
     * @throws ApiError
     */
    public static creativeControllerRegenerateMusicV1(
        creativeId: string,
        requestBody: RegenerateReelMusicDto,
    ): CancelablePromise<RegenerateReelMusicResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{creativeId}/regenerate-music',
            path: {
                'creativeId': creativeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Synthesize one reel beat’s voiceover for the live preview (Play speaks before any render). Sync (a few seconds); the mp3 is stored durably, captions re-time from word timings, and the next render reuses the take. Free (no credit).
     * @param creativeId Creative ID
     * @param requestBody
     * @returns SynthBeatVoResponseDto
     * @throws ApiError
     */
    public static creativeControllerSynthBeatVoV1(
        creativeId: string,
        requestBody: SynthBeatVoDto,
    ): CancelablePromise<SynthBeatVoResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{creativeId}/synth-beat-vo',
            path: {
                'creativeId': creativeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Hydrate a blueprint reel: film every still-planned beat, then render + score the master. Async 202; also the idempotent RESUME after a parked/failed hydration (skips beats already filled). Charges the one video credit if not already charged.
     * @param creativeId Creative ID
     * @returns any { status: "hydrating" }
     * @throws ApiError
     */
    public static creativeControllerBringToLifeV1(
        creativeId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{creativeId}/bring-to-life',
            path: {
                'creativeId': creativeId,
            },
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * List the version journey (scored checkpoints) for a creative
     * @param creativeId Creative ID
     * @returns CreativeVersionListResponseDto
     * @throws ApiError
     */
    public static creativeControllerListVersionsV1(
        creativeId: string,
    ): CancelablePromise<CreativeVersionListResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/{creativeId}/versions',
            path: {
                'creativeId': creativeId,
            },
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Get one version's full restorable document (composition + content)
     * @param creativeId Creative ID
     * @param seq Version number
     * @returns CreativeVersionDetailResponseDto
     * @throws ApiError
     */
    public static creativeControllerGetVersionV1(
        creativeId: string,
        seq: number,
    ): CancelablePromise<CreativeVersionDetailResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/{creativeId}/versions/{seq}',
            path: {
                'creativeId': creativeId,
                'seq': seq,
            },
            errors: {
                404: `Creative or version not found`,
            },
        });
    }
    /**
     * Restore a version (non-destructive: brings its state back as a new tip version)
     * @param creativeId Creative ID
     * @param seq Version number to restore
     * @returns CreativeVersionListResponseDto
     * @throws ApiError
     */
    public static creativeControllerRestoreVersionV1(
        creativeId: string,
        seq: number,
    ): CancelablePromise<CreativeVersionListResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{creativeId}/versions/{seq}/restore',
            path: {
                'creativeId': creativeId,
                'seq': seq,
            },
            errors: {
                404: `Creative or version not found`,
            },
        });
    }
    /**
     * Get a creative by ID with its active chat
     * @param id Creative ID
     * @returns CreativeWithChatResponseDto
     * @throws ApiError
     */
    public static creativeControllerFindOneV1(
        id: string,
    ): CancelablePromise<CreativeWithChatResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Update a creative
     * @param id Creative ID
     * @param requestBody
     * @returns CreativeEntity
     * @throws ApiError
     */
    public static creativeControllerUpdateV1(
        id: string,
        requestBody: UpdateCreativeDto,
    ): CancelablePromise<CreativeEntity> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/creatives/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Delete a creative
     * @param id Creative ID
     * @returns any Creative deleted
     * @throws ApiError
     */
    public static creativeControllerDeleteV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/creatives/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Bring-your-own-content: create a Post from user-uploaded media, published untouched (no AI generation, 0 credits)
     * @param requestBody
     * @returns CreateFromUploadResponseDto
     * @throws ApiError
     */
    public static creativeControllerCreateFromUploadV1(
        requestBody: CreateFromUploadDto,
    ): CancelablePromise<CreateFromUploadResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/from-upload',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Trigger background AI content generation for an existing (typically empty) creative
     * @param id Creative ID
     * @param requestBody
     * @returns any Generation started
     * @throws ApiError
     */
    public static creativeControllerGenerateContentV1(
        id: string,
        requestBody?: GenerateCreativeContentDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/generate-content',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Promote a suggestion to a regular creative
     * @param id Creative ID
     * @returns CreativeEntity
     * @throws ApiError
     */
    public static creativeControllerPromoteSuggestionV1(
        id: string,
    ): CancelablePromise<CreativeEntity> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/promote',
            path: {
                'id': id,
            },
            errors: {
                404: `Creative not found`,
            },
        });
    }
    /**
     * Publish an Instagram creative to Instagram
     * @param id Creative ID
     * @returns any Post published successfully
     * @throws ApiError
     */
    public static creativeControllerPublishToInstagramV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/publish-instagram',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid creative or missing image`,
            },
        });
    }
    /**
     * Publish a creative to TikTok
     * @param id Creative ID
     * @returns any Publish started — progress sent via Pusher
     * @throws ApiError
     */
    public static creativeControllerPublishToTikTokV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/publish-tiktok',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid creative or missing video`,
            },
        });
    }
    /**
     * Publish a YouTube Short to YouTube
     * @param id Creative ID
     * @returns any Publish started — progress sent via Pusher
     * @throws ApiError
     */
    public static creativeControllerPublishToYouTubeV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/publish-youtube',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid creative or missing video`,
            },
        });
    }
    /**
     * Publish a LinkedIn creative to LinkedIn
     * @param id Creative ID
     * @returns any Post published successfully
     * @throws ApiError
     */
    public static creativeControllerPublishToLinkedInV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/publish-linkedin',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid creative or missing content`,
            },
        });
    }
    /**
     * Publish a creative to X (Twitter)
     * @param id Creative ID
     * @returns any Publish started — progress sent via Pusher
     * @throws ApiError
     */
    public static creativeControllerPublishToXV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/publish-x',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid creative or missing content`,
            },
        });
    }
    /**
     * Publish a Facebook creative to a Facebook Page
     * @param id Creative ID
     * @returns any Post published successfully
     * @throws ApiError
     */
    public static creativeControllerPublishToFacebookV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/publish-facebook',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid creative or missing content`,
            },
        });
    }
    /**
     * List Facebook Pages managed by the current user
     * @returns any List of Facebook Pages
     * @throws ApiError
     */
    public static creativeControllerListFacebookPagesV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/creatives/facebook/pages',
        });
    }
    /**
     * Publish a Pinterest creative as a Pin
     * @param id Creative ID
     * @returns any Publish started — progress sent via Pusher
     * @throws ApiError
     */
    public static creativeControllerPublishToPinterestV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/publish-pinterest',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid creative or missing image`,
            },
        });
    }
}
